import { render } from "./KriRegistry.vue?vue&type=template&id=91ac70b4&scoped=true"
import script from "./KriRegistry.js?vue&type=script&lang=js"
export * from "./KriRegistry.js?vue&type=script&lang=js"

import "./KriRegistry.vue?vue&type=style&index=0&id=91ac70b4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91ac70b4"]])

export default __exports__